export default {
  title: 'Access denied',
  description: 'You do not have permission to view this page. Contact an administrator to request access.',
  back: 'Back to dashboard'
}
